import WifiConfig from "@/components/Elemnt/Wifi/WifiConfig";
import { useParams } from "react-router";

const WifiConfigPage = () => {
  const { appToken = "" } = useParams();
  return <WifiConfig appToken={appToken} />;
};

export default WifiConfigPage;
